var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404 页面未找到")]),_c('p',[_vm._v("抱歉，您所访问的页面可能在另一个地方。")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }